import { defineStore } from 'pinia';
import api from '@/services/api';
import procesoService from '@/services/proceso_service';

export const useProcesoStore = defineStore('procesoStore', {
  state: () => ({
    procesoList: [],
    page: 1,
    procesosEtiquetasList: [],
    pageProcesosEtiquetas: 1,
  }),
  actions: {
    async findAllProcesosHTTP(queryParams) {
      const result = await api.get(
        `/proceso?${new URLSearchParams({
          page: 1,
          sortBy: 'Descripcion',
          sort: 'asc',
          Activo: true,
          ...queryParams,
        }).toString()}`,
      );
      if (result && result.data) {
        this.procesoList.splice(0, this.procesoList.length, ...result.data);
        this.setPage(this.page + 1);
        return true;
      }
    },
    async findAllProcesosEtiquetasHTTP() {
      try {
        const result = await procesoService.findAllEtiquetas(this.pageProcesosEtiquetas);
        if (result && result.data) {
          this.procesosEtiquetasList.splice(0, this.procesosEtiquetasList.length, ...result.data);
          this.setPageProcesosEtiquetas(this.pageProcesosEtiquetas + 1);
          return true;
        }
        return false;
      } catch (error) {
        console.error('Error in findAllProcesosEtiquetasHTTP:', error);
        return false;
      }
    },
    async searchProcesoHTTP(query) {
      try {
        const result = await procesoService.searchByDescription(query, 1);
        if (result && result.data && result.data.length > 0) {
          return [...result.data];
        }
        return [];
      } catch (error) {
        console.error('Error in searchProcesoHTTP:', error);
        return [];
      }
    },
    async firstProceso() {
      this.setPage(1);
      this.emptyList();
      await this.findAllProcesosHTTP();
    },
    setPage(page) {
      this.page = page;
    },
    setPageProcesosEtiquetas(pageProcesosEtiquetas) {
      this.pageProcesosEtiquetas = pageProcesosEtiquetas;
    },
    emptyList() {
      this.procesoList = [];
    },
    getProcesosSustratos() {
      return this.procesoList.filter((p) => p.CodigoMaterialCategoria === 1).map((s) => s.Codigo);
    },
  },
});
